import React, { useState, useEffect } from 'react';
import { Badge, Dropdown, List, Button, Typography, Empty } from 'antd';
import { BellOutlined, DeleteOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface Notification {
  id: string;
  type: string;
  message: string;
  timestamp: string;
  read: boolean;
}

interface NotificationBellProps {
  notifications: Notification[];
  onMarkAsRead: (id: string) => void;
  onClearAll: () => void;
}

const NotificationBell: React.FC<NotificationBellProps> = ({
  notifications,
  onMarkAsRead,
  onClearAll,
}) => {
  const unreadCount = notifications.filter(n => !n.read).length;

  const dropdownContent = (
    <div style={{ width: 320, maxHeight: 400, overflow: 'auto', backgroundColor: '#fff', borderRadius: 6, boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)' }}>
      <div style={{ 
        padding: '8px 16px', 
        borderBottom: '1px solid #f0f0f0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <Text strong>通知 ({unreadCount})</Text>
        {notifications.length > 0 && (
          <Button 
            type="text" 
            size="small" 
            icon={<DeleteOutlined />}
            onClick={onClearAll}
          >
            全削除
          </Button>
        )}
      </div>
      
      {notifications.length === 0 ? (
        <div style={{ padding: 16 }}>
          <Empty 
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="通知はありません"
          />
        </div>
      ) : (
        <List
          dataSource={notifications}
          renderItem={(item) => (
            <List.Item
              style={{ 
                padding: '12px 16px',
                backgroundColor: item.read ? 'transparent' : '#f6ffed',
                cursor: 'pointer'
              }}
              onClick={() => onMarkAsRead(item.id)}
            >
              <div style={{ width: '100%' }}>
                <div style={{ 
                  fontSize: '11px', 
                  marginBottom: 4,
                  color: item.read ? '#666' : '#262626',
                  fontFamily: 'monospace',
                  whiteSpace: 'pre-wrap',
                  maxHeight: '200px',
                  overflow: 'auto'
                }}>
                  {item.message}
                </div>
                <div style={{ fontSize: '11px', color: '#999' }}>
                  {new Date(item.timestamp).toLocaleString()}
                </div>
              </div>
            </List.Item>
          )}
        />
      )}
    </div>
  );

  return (
    <Dropdown
      overlay={dropdownContent}
      trigger={['click']}
      placement="bottomRight"
    >
      <Badge count={unreadCount} size="small">
        <Button 
          type="text" 
          icon={<BellOutlined />}
          style={{ 
            color: unreadCount > 0 ? '#1890ff' : '#666',
            fontSize: '16px'
          }}
        />
      </Badge>
    </Dropdown>
  );
};

export default NotificationBell;